import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from "lodash";

require('./bringoz-primary-capacity.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-primary-capacity',
  templateUrl: './bringoz-primary-capacity.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozPrimaryCapacityComponent implements OnInit, OnChanges {

  @Input() weight?: number;
  @Input() maxWeight?: number;
  @Input() volume?: number;
  @Input() maxVolume?: number;
  @Input() maxDimensions?: {
    height: number;
    width: number;
    length: number;
  };
  @Input() packages?: number;
  @Input() maxPackages?: number;
  @Input() spots?: number;
  @Input() maxSpots?: number;

  @Input() weightEnabled?: boolean;
  @Input() volumeEnabled?: boolean;
  @Input() packagesEnabled?: boolean;
  @Input() spotsEnabled?: boolean;

  public capacity: {
    type: string,
    icon: string,
    value: number,
    maxValue: number,
    percentage: number,
    enabled: boolean,
    unit: string;
  };

  constructor(@Inject('splitService') private splitService) {}

  ngOnInit() {
    this.setCapacityBar();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setCapacityBar();
  }

  private setCapacityBar() {
    let weightPercentage, volumePercentage, packagesPercentage, spotsPercentage;
    let weight, maxWeight, volume, maxVolume, packages, maxPackages, spots, maxSpots;

    if (this.weightEnabled) {
      weight = this.weight || 0;
      maxWeight = this.maxWeight || 0;

      if (!!maxWeight) {
        weightPercentage = weight ? (weight / maxWeight * 100) : 0;
      }
    }
    if (this.volumeEnabled) {
      volume = this.volume || 0;
      maxVolume = this.maxDimensions ?
        (this.maxDimensions.height * this.maxDimensions.width * this.maxDimensions.length) : (this.maxVolume || 0);

      if (!!maxVolume) {
        volumePercentage = volume ? (volume / maxVolume * 100) : 0;
      }
    }

    if (this.packagesEnabled) {
      packages = this.packages || 0;
      maxPackages = this.maxPackages || 0;

      if (!!maxPackages) {
        packagesPercentage = packages ? (packages / maxPackages * 100) : 0;
      }
    }
    if (this.spotsEnabled) {
      spots = this.spots || 0;
      maxSpots = this.maxSpots || 0;

      if (!!maxSpots) {
        spotsPercentage = spots ? (spots / maxSpots * 100) : 0;
      }
    }

    let largestPercentage = 0;
    let icon;
    let type;
    let value;
    let maxValue;
    let unit;

    if (!!weightPercentage && weightPercentage > largestPercentage) {
      largestPercentage = weightPercentage;
      icon = 'weight';
      type = 'weight';
      value = weight;
      maxValue = maxWeight;
      unit = this.splitService.getWeightUnit();
    }
    if (!!volumePercentage && volumePercentage > largestPercentage) {
      largestPercentage = volumePercentage;
      icon = 'volume';
      type = 'volume';
      value = volume;
      maxValue = maxVolume;
      unit = this.splitService.getVolumeUnit();
    }
    if (!!packagesPercentage && packagesPercentage > largestPercentage) {
      largestPercentage = packagesPercentage;
      icon = 'package-outline';
      type = 'packages';
      value = packages;
      maxValue = maxPackages;
    }
    if (!!spotsPercentage && spotsPercentage > largestPercentage) {
      largestPercentage = spotsPercentage;
      icon = 'spot';
      type = 'spots';
      value = spots;
      maxValue = maxSpots;
    }

    this.capacity = {
      type: type,
      icon: icon,
      value: value,
      maxValue: maxValue,
      percentage: Math.round(largestPercentage),
      enabled: (this.weightEnabled || this.volumeEnabled || this.packagesEnabled || this.spotsEnabled),
      unit: unit
    }

  }

}
